import { useContext } from "react";
import AccountContext from "../components/AccountContext";

export default function useAccount() {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error("useAccount must be used within a AccountProvider");
  }
  return context;
}
